import { render } from "./OptionalTelephone.vue?vue&type=template&id=425ab352&scoped=true"
import script from "./OptionalTelephone.vue?vue&type=script&lang=js"
export * from "./OptionalTelephone.vue?vue&type=script&lang=js"

import "./OptionalTelephone.vue?vue&type=style&index=0&id=425ab352&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425ab352"]])

export default __exports__